export default class PersonTypeDomainService {
    static get DefaultPersonTypeInternalName() {
        return "student";
    }
    static get StudentPersonTypeInternalName() {
        return "student";
    }
    static get StaffPersonTypeInternalName() {
        return "staff";
    }
    static get ProspectPersonTypeInternalName() {
        return "prospect";
    }
    static get ApplicantPersonTypeInternalName() {
        return "applicant";
    }
    static get FacultyPersonTypeInternalName() {
        return "faculty";
    }
}
